module.exports = __webpack_public_path__ + "/bundle/asset/relation-b98ab566203b3bd66bd876a4dff70994.png";